import './bml-about-us-banner.scss';
const TEMPLATE = `
<section class="main-banner-about-us fade-up">
    <div class="about-us-circles-wrapper" data-animate-circles>
        <!-- Білі кола -->
        <div class="about-us-circle about-us-circle-extra-large"></div>
        <div class="about-us-circle about-us-circle-large"></div>
        <div class="about-us-circle about-us-circle-medium"></div>
    </div>
    <p data-animate-child class="subhead">
        Довіра до точності
    </p>
    <h1 data-animate-child class="banner-h1-top">Діагностика, <span data-animate-child
            class="image-placeholder d-none d-md-inline-block"></span>
        що визначає</h1>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-6"></div>
            <div class="col-lg-6 col-md-6">
                <h1 data-animate-child class="banner-h1-bottom">лікування</h1>
                <span data-animate-child class="image-placeholder d-md-none d-block mx-auto"></span>
            </div>
        </div>
    </div>
</section>
`;

class BmlAboutUsBanner extends HTMLElement {
    connectedCallback() { if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE; }
}
customElements.define('bml-about-us-banner', BmlAboutUsBanner);
